import { TimeWithDays } from './../../models/api/route-plan.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateTime',
})
export class TranslateTimePipe implements PipeTransform {
  transform(value: TimeWithDays, type: string): string {
    switch (type) {
      case 'd|h|min':
      default:
        return (
          (value.days ? value.days + 'd ' : '') +
          (value.hours ? value.hours + 'h ' : '') +
          value.minutes +
          'min'
        );
    }
  }
}
